
import { defineStore } from "pinia";
import apiClient from "@/apiClient";

export const useTicketStore = defineStore("ticket", {
  state: () => ({
    unansweredCount: null,
    unreadLoaded: false,
    unreadLoading: false,
    listRefreshKey: 0,
  }),

  actions: {
    async fetchUnansweredCount({ force = false } = {}) {
      if (this.unreadLoading) {
        return this.unansweredCount;
      }

      if (this.unreadLoaded && !force) {
        return this.unansweredCount;
      }

      this.unreadLoading = true;

      try {
        const { data } = await apiClient.get("/api/ticket/unanswered-count");
        this.unansweredCount = Number(data?.count ?? 0);
        this.unreadLoaded = true;
      } catch (error) {
        console.error(error);
      } finally {
        this.unreadLoading = false;
      }

      return this.unansweredCount;
    },

    setUnansweredCount(count) {
      this.unansweredCount = Number(count ?? 0);
      this.unreadLoaded = true;
    },

    requestListRefresh() {
      this.listRefreshKey += 1;
    },
  },
});
